var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconmonstr-whatsapp-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-volunteer-campaign-page",
    transform: "translate(-1320.000000, -1931.000000)",
    fill: "#24CC64",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons",
    transform: "translate(1304.000000, 1787.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-whatsapp-4",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.031,6.172 C8.85,6.172 6.264,8.758 6.26299804,11.938 C6.262,13.236 6.643,14.208 7.282,15.225 L6.7,17.353 L8.882,16.78 C9.86,17.36 10.793,17.708 12.027,17.709 C15.205,17.709 17.794,15.122 17.7950003,11.943 C17.796,8.756 15.22,6.173 12.031,6.172 L12.031,6.172 Z M15.423,14.416 C15.279,14.821 14.586,15.19 14.253,15.24 C13.954,15.285 13.576,15.303 13.161,15.171 C12.909,15.091 12.586,14.984 12.173,14.806 C10.434,14.055 9.299,12.304 9.212,12.189 C9.125,12.073 8.504,11.249 8.504,10.396 C8.504,9.543 8.952,9.123 9.111,8.95 C9.27,8.777 9.457,8.733 9.573,8.733 L9.905,8.739 C10.011,8.744 10.154,8.699 10.295,9.037 C10.439,9.384 10.786,10.237 10.829,10.324 C10.872,10.411 10.901,10.512 10.843,10.628 C10.785,10.744 10.756,10.816 10.67,10.917 L10.41,11.221 C10.323,11.307 10.233,11.401 10.334,11.575 C10.435,11.749 10.783,12.316 11.298,12.776 C11.96,13.367 12.519,13.55 12.692,13.636 C12.865,13.722 12.966,13.708 13.068,13.593 C13.169,13.477 13.501,13.087 13.617,12.913 C13.733,12.74 13.848,12.768 14.007,12.826 C14.166,12.884 15.018,13.303 15.191,13.39 C15.364,13.477 15.48,13.52 15.523,13.592 C15.568,13.664 15.568,14.011 15.423,14.416 L15.423,14.416 Z M12,0 C5.373,0 0,5.373 0,12 C0,18.627 5.373,24 12,24 C18.627,24 24,18.627 24,12 C24,5.373 18.627,0 12,0 Z M12.029,18.88 C10.868,18.88 9.724,18.588 8.711,18.036 L5.034,19 L6.018,15.405 C5.411,14.353 5.091,13.159 5.092,11.937 C5.093,8.112 8.205,5 12.029,5 C13.885,5.001 15.627,5.723 16.936,7.034 C18.246,8.345 18.967,10.088 18.966001,11.942 C18.965,15.767 15.853,18.88 12.029,18.88 L12.029,18.88 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.4530286d9e5e2ffb7d64b7283eb995d9.svg";
export { ForwardRef as ReactComponent };